export const imageValidator = (file: File): [boolean, string | undefined] => {
    const ALLOWED_FORMATS = ['image/png', 'image/jpeg', 'image/jpg'];
    if (file.size > 2 * 1024 * 1024)
        return [false, 'Image file size should not exceed 2 MiB'];
    try {
        if (!ALLOWED_FORMATS.includes(file.type))
            return [false, 'Only .jpg, .jpeg, .png file types are accepted'];
    } catch (err) {
        return [false, 'Something weng wrong while uploading your image. Please try again'];
    }
    return [true, undefined];
};
